import { useDocumentationBrowserState } from 'components/documentation/DocumentationBrowser';

export function useImportFromDocumentationBrowser(isOpen: boolean) {
  return useDocumentationBrowserState({
    isOpen,
    selectableDocumentation: true,
    singleDocumentationSelection: true,
  });
}
